import { useIsApiReady } from "@/hooks/use-api-ready";
import { groupControllerGetGroupModelProfiles } from "@/lib/gen-api";
import { queryKeys } from "@/lib/query-keys";
import { useQuery } from "@tanstack/react-query";

export const selectGroupModelProfile = <
  T extends { uuid: string; isDefault: boolean },
>(
  modelProfiles: T[],
  modelProfileUuid: string | undefined,
): T | undefined => {
  const matched = modelProfileUuid
    ? modelProfiles.find((profile) => profile.uuid === modelProfileUuid)
    : undefined;

  return (
    matched ??
    modelProfiles.find((profile) => profile.isDefault) ??
    modelProfiles[0]
  );
};

export const useGroupModelProfilesData = (groupUuid: string | null) => {
  const { data: modelProfiles, isPending } = useQuery({
    enabled: useIsApiReady() && !!groupUuid,
    queryKey: queryKeys.groupModels(groupUuid!),
    queryFn: () =>
      groupControllerGetGroupModelProfiles({
        path: {
          groupUuid: groupUuid!,
        },
      }).then((res) => res.data?.data ?? []),
  });

  return {
    modelProfiles: modelProfiles ?? [],
    isLoadingModelProfiles: isPending,
  };
};
